// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgFlagIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="M17.24 1.96c-.09-.29-.31-.53-.6-.64a.99.99 0 0 0-.87.08l-1.13.68c-1.39.84-2.98 1.2-4.6 1.07C8.22 3 6.42 3.36 4.8 4.2l-.11-.35a.986.986 0 0 0-1.26-.64c-.53.17-.81.74-.64 1.26l5.66 17.35a1 1 0 0 0 1.1.68c.05 0 .11-.02.16-.04.53-.17.81-.74.64-1.26l-2.14-6.56a7.6 7.6 0 0 1 4.28-.89 9.6 9.6 0 0 0 3.63-.38 9.6 9.6 0 0 0 2.17-.97l1.13-.68c.39-.24.58-.71.44-1.15z" />
  </g>
);
export default SvgFlagIcon;
SvgFlagIcon.displayName = 'SvgFlagIcon';
